import { IconAI } from '../base/icons/svg';
import { DEFAULT_CUSTOM_PANEL_WIDTH } from './constants';
/**
 * Module-level variable to store custom JWT token.
 * This allows the JWT to be accessed by components without Redux state changes.
 */
let customPanelJWT;
/**
 * Sets the custom JWT token for the custom panel.
 *
 * @param {string | undefined} jwt - The JWT token to store.
 * @returns {void}
 */
export function setCustomPanelJWT(jwt) {
    customPanelJWT = jwt;
}
/**
 * Returns the JWT token to use for the custom panel.
 * Prioritizes custom JWT from module scope, falls back to meeting JWT.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {string | undefined} The JWT token to use.
 */
export function getCustomPanelJWT(state) {
    // First check if custom JWT was provided via enableCustomPanel().
    if (customPanelJWT) {
        return customPanelJWT;
    }
    // Fall back to meeting JWT.
    return state['features/base/jwt']?.jwt;
}
/**
 * Returns whether the custom panel feature is enabled based on Redux state.
 * The feature is disabled by default and can be enabled dynamically via console.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {boolean} Whether the custom panel feature is enabled.
 */
export function isCustomPanelEnabled(state) {
    return Boolean(state['features/custom-panel']?.enabled);
}
/**
 * Returns the custom panel URL.
 *
 * @returns {string} The URL to load in the custom panel iframe.
 */
export function getCustomPanelUrl() {
    return 'https://advisor.ai.8x8.vc';
}
/**
 * Returns the custom panel button icon.
 *
 * @returns {Function} The icon component to display in the toolbar button.
 */
export function getCustomPanelIcon() {
    return IconAI;
}
/**
 * Returns the configured panel width.
 *
 * @returns {number} The panel width in pixels.
 */
export function getCustomPanelConfiguredWidth() {
    return DEFAULT_CUSTOM_PANEL_WIDTH;
}
/**
 * Returns whether the custom panel is currently open.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {boolean} Whether the custom panel is open.
 */
export function getCustomPanelOpen(state) {
    return Boolean(state['features/custom-panel']?.isOpen);
}
/**
 * Returns the current panel width (0 if closed).
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {number} The panel width in pixels.
 */
export function getCustomPanelWidth(state) {
    return getCustomPanelOpen(state) ? getCustomPanelConfiguredWidth() : 0;
}
